
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/device-info",
      function () {
        return require("private-next-pages/device-info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/device-info"])
      });
    }
  